export const ComboboxItem = "CALCITE-COMBOBOX-ITEM";
export const ComboboxItemGroup = "CALCITE-COMBOBOX-ITEM-GROUP";
export const ComboboxChildSelector = `${ComboboxItem}, ${ComboboxItemGroup}`;

export const CSS = {
  chipInvisible: "chip--invisible",
  selectionDisplayFit: "selection-display-fit",
  selectionDisplaySingle: "selection-display-single",
  listContainer: "list-container",
};
